package ru.malygin.urls.tech

import ru.malygin.myConst.jsMainIsDebug

private fun urlServDev(port: String) = "http://localhost:$port"

private fun urlServProd() = "https://prk-be.cyberdemon.ru"


/**
 *
 * "https://prk-be.cyberdemon.ru"                    -   пример
 *
 * "http://localhost:32556"                          -   пример
 *
 * "https://faintly-developing-hoopoe.cloudpub.ru"   -   пример
 *
 * @param isDev  true - dev, false - prod
 * @param port  port (dev only)
 *
 * @return [String] - путь до сервера

 */
fun urlServ(isDev: Boolean = jsMainIsDebug, port: String = "32556") = if (isDev) urlServDev(port) else urlServProd()
